import jsrender from 'jsrender';

const templateScreenButtonListItem = jsrender.templates(require('./screen-button-list-item.tmpl'));
const templateCart = jsrender.templates(require('./cart-template.tmpl'));
const templatePricetypeSelectionPopup = jsrender.templates(require('./pricetype-selection-popup-template.tmpl'));
const templateSeatInfoPopover = jsrender.templates(require('./seat-info-popover-template.tmpl'));


export {
  templateScreenButtonListItem,
  templateCart,
  templatePricetypeSelectionPopup,
  templateSeatInfoPopover,
};



// WEBPACK FOOTER //
// ./src/syos/templates/templates.js